import { Component, OnInit } from '@angular/core';

import { WindowService } from '@app/utils/window.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'om-design',
  template: ``,
})
export class DesignComponent implements OnInit {
  constructor(private windowService: WindowService) {}

  ngOnInit() {
    if (environment.designSystemUrl) {
      this.windowService.redirect(environment.designSystemUrl);
    } else {
      this.windowService.redirect('/');
    }
  }
}
